( function () {
	'use strict';

	/* @ngInject */

	function AddEditCounterController ( $rootScope, logger, evidence, observation, level, $modalInstance, apiService, TOOLTIP_MESSAGES ) {
		var self = this;

		self.title = 'AddEditCounterController';

		var quickAccess;

		function incrementCounterHandler () {
			self.counter += 1;
		}

		function decrementCounterHandler () {
			if ( self.counter ) {
				self.counter -= 1;
			}
		}

		function closeView () {
			$modalInstance.close();
		}

		function saveEvidence () {
			// add evidence
			self.evidence.name        = self.name;
			self.evidence.description = self.counter.toString();

			if ( !level.evidences ) {
				level.evidences = [ ];
			}

			level.evidences.push( angular.copy( self.evidence ) );

			if ( !observation.masterEvidences ) {
				observation.masterEvidences = [ ];
			}

			observation.masterEvidences.push( angular.copy( self.evidence ) );

			quickAccess = {
				'activeTimer'  : false,
				'type'         : 6,
				'evidenceData' : self.evidence
			};

			// collapse quick access
			$rootScope.$broadcast( 'quick:access:collapse' );

			$rootScope.$broadcast( 'updateObs', quickAccess );
			closeView();
		}

		function cancelChanges () {
			$modalInstance.dismiss();
		}

		self.incrementCounterHandler = incrementCounterHandler;
		self.decrementCounterHandler = decrementCounterHandler;
		self.closeView               = closeView;
		self.saveEvidence            = saveEvidence;
		self.cancelChanges           = cancelChanges;
		self.tooltip                 = TOOLTIP_MESSAGES;

		function activate () {
			logger.info( 'Activated Add/Edit Counter Controller' );

			self.counter  = 0;
			self.evidence = {
				'id'          : apiService.generateUUID(),
				'name'        : '',
				'description' : '',
				'type'        : 6,
				'scope'       : 'public'
			};
			self.name        = 'Counter';
			self.showLoading = false;
		}

		activate();

		$rootScope.$on( 'close:add:modal', function () {
			closeView();
		} );
	}

	angular
		.module( 'app.components' )
		.controller( 'AddEditCounterController', AddEditCounterController );

	AddEditCounterController.$inject = [ '$rootScope', 'logger', 'evidence', 'observation', 'level', '$modalInstance', 'apiService', 'TOOLTIP_MESSAGES' ];
} )( );
